import { createContext } from "react";

const InductionContext = createContext();

export default InductionContext